export default $compileProvider => {
    "ngInject";
    $compileProvider.debugInfoEnabled(false);
};
